export default "__VITE_ASSET__9b6c73e3__"